import BaseApi from './BaseApi';

export type Staff = {
  cognitoId?: string;
  companyId?: string;
  userId?: string;
  mail?: string;
  displayName?: string;
  type?: string;
  staffId?: string;
  isInactive?: boolean;
  lastLogin?: number;
  sub?: string;
};

/**
 * スタッフ一覧取得API。
 */
class GetCompanyStaffListApi extends BaseApi {
  async get() {
    return await this.execute('getCompanyStaffListApi', {
      method: 'GET'
    }).then(({ result }) => result as Staff[]);
  }
}

export default GetCompanyStaffListApi;
